/* eslint-disable no-unused-vars */
import React from 'react';
import PropTypes from 'prop-types';
import { Form, Input, Select } from 'antd';
import { Box, Flex } from 'atoms';
import {
	StyledForm,
	FormSection,
	AddButton,
	CancelButton,
	SubmitButton,
} from './CreateVehicleTypePageV2.styles';

const { Option } = Select;

function VehicleTypeForm({
	form,
	isEditMode,
	makerOptions,
	modelOptions,
	selectedMaker,
	loading,
	handleMakerChange,
	handleAddVehicle,
	handleBack,
	handleSubmit,
}) {
	return (
		<FormSection>
			<StyledForm form={form} layout="vertical">
				<Flex gap="16px" flexWrap="wrap">
					<Box flex="1" minWidth="300px">
						<Form.Item
							label="Maker/Manufacturer"
							name="maker"
							rules={[{ required: true, message: 'Please enter maker' }]}
						>
							{/* Dropdown - commented out for now
							<Select
								placeholder="Select"
								size="large"
								getPopupContainer={(trigger) => trigger.parentNode}
								onChange={handleMakerChange}
							>
								{makerOptions.map((maker) => (
									<Option key={maker} value={maker}>
										{maker}
									</Option>
								))}
							</Select>
							*/}
							<Input placeholder="Enter maker" size="large" />
						</Form.Item>
					</Box>

					<Box flex="1" minWidth="300px" ml="16px">
						<Form.Item
							label="Model Name"
							name="modelName"
							rules={[{ required: true, message: 'Please enter model name' }]}
						>
							{/* Dropdown - commented out for now
							<Select
								placeholder="Select"
								size="large"
								getPopupContainer={(trigger) => trigger.parentNode}
								disabled={!selectedMaker}
								notFoundContent="Please select a maker first"
							>
								{modelOptions.map((model) => (
									<Option key={model} value={model}>
										{model}
									</Option>
								))}
							</Select>
							*/}
							<Input placeholder="Enter model name" size="large" />
						</Form.Item>
					</Box>
				</Flex>

				<Flex gap="16px" flexWrap="wrap">
					<Box flex="1" minWidth="300px">
						<Form.Item
							label="Capacity (in tonnes)"
							name="capacity"
							rules={[
								{ required: true, message: 'Please enter capacity' },
								{
									type: 'number',
									min: 0.01,
									max: 999.99,
									message: 'Capacity must be between 0.01 and 999.99',
									transform: (value) => Number(value),
								},
							]}
						>
							<Input
								placeholder="Eg. 12.50"
								size="large"
								type="number"
								step="0.01"
								min="0.01"
								max="999.99"
							/>
						</Form.Item>
					</Box>

					<Box flex="1" minWidth="300px" ml="16px">
						<Form.Item
							label="Length (in feet)"
							name="length"
							rules={[
								{ required: true, message: 'Please enter length' },
								{
									type: 'number',
									min: 0.01,
									max: 999.99,
									message: 'Length must be between 0.01 and 999.99',
									transform: (value) => Number(value),
								},
							]}
						>
							<Input
								placeholder="Eg. 10.50"
								size="large"
								type="number"
								step="0.01"
								min="0.01"
								max="999.99"
							/>
						</Form.Item>
					</Box>
				</Flex>

				<Flex gap="16px" flexWrap="wrap">
					<Box flex="1" minWidth="300px">
						<Form.Item
							label="Temperature Controlled"
							name="tempControlled"
							rules={[
								{
									required: true,
									message: 'Please select temperature control',
								},
							]}
						>
							<Select
								placeholder="Select"
								size="large"
								getPopupContainer={(trigger) => trigger.parentNode}
							>
								<Option value="true">Yes</Option>
								<Option value="false">No</Option>
							</Select>
						</Form.Item>
					</Box>

					<Box flex="1" minWidth="300px" ml="16px">
						<Form.Item
							label="Driver Mode"
							name="driverMode"
							rules={[{ required: true, message: 'Please select driver mode' }]}
						>
							<Select
								placeholder="Select"
								size="large"
								getPopupContainer={(trigger) => trigger.parentNode}
							>
								<Option value="Manual">Manual</Option>
								<Option value="Automatic">Automatic</Option>
							</Select>
						</Form.Item>
					</Box>
				</Flex>

				<Flex gap="16px" flexWrap="wrap">
					<Box flex="1" minWidth="300px">
						<Form.Item
							label="Fuel Type"
							name="fuelType"
							rules={[{ required: true, message: 'Please select fuel type' }]}
						>
							<Select
								placeholder="Select"
								size="large"
								getPopupContainer={(trigger) => trigger.parentNode}
							>
								<Option value="Petrol">Petrol</Option>
								<Option value="Diesel">Diesel</Option>
								<Option value="Electric">Electric</Option>
								<Option value="CNG">CNG</Option>
							</Select>
						</Form.Item>
					</Box>
				</Flex>

				{!isEditMode && (
					<Flex justifyContent="center" mt={2}>
						<AddButton type="primary" onClick={handleAddVehicle}>
							Add Vehicle
						</AddButton>
					</Flex>
				)}

				{/* Edit mode: Show Save Changes and Cancel buttons */}
				{isEditMode && (
					<Flex justifyContent="flex-end" gap="12px" mt={4}>
						<CancelButton onClick={handleBack}>Cancel</CancelButton>
						<SubmitButton type="primary" onClick={handleSubmit} loading={loading}>
							Save Changes
						</SubmitButton>
					</Flex>
				)}
			</StyledForm>
		</FormSection>
	);
}

VehicleTypeForm.propTypes = {
	form: PropTypes.object.isRequired,
	isEditMode: PropTypes.bool.isRequired,
	makerOptions: PropTypes.arrayOf(PropTypes.string).isRequired,
	modelOptions: PropTypes.arrayOf(PropTypes.string).isRequired,
	selectedMaker: PropTypes.string,
	loading: PropTypes.bool,
	handleMakerChange: PropTypes.func.isRequired,
	handleAddVehicle: PropTypes.func.isRequired,
	handleBack: PropTypes.func.isRequired,
	handleSubmit: PropTypes.func.isRequired,
};

VehicleTypeForm.defaultProps = {
	selectedMaker: null,
	loading: false,
};

export default VehicleTypeForm;
